module.exports = __webpack_public_path__ + "files/06abe574e89b318c72f9d46b549453c8.png";